import FormDialog from "../../../components/dialog/form/FormDialog.vue";
import SelectField from "../../../components/fields/selectField/SelectField.vue";
import TextField from "../../../components/fields/textField/TextField.vue";
import TextAreaField from "../../../components/fields/textAreaField/TextAreaField.vue";
import PeriodoField from "../../../components/fields/periodoField/PeriodoField.vue";
import {
  AnalisarFeriasService
} from "../../../services/AnalisarFeriasService";


export default {
  name: "AnalisarFeriasEscolares",

  components: {
    FormDialog,
    SelectField,
    TextField,
    PeriodoField,
    TextAreaField
  },

  props: {
    selected: {
      type: Array,
      required: true,
    },

  },

  data: () => ({
    data: [],
    justificativa: "",

    justificativaDialog: false,

    loading: {
      btn: false,
      field: false,
      btnApprove: false,
      btnRefuse: false,
    },
  }),

  methods: {
    prepareForm() {
      const formData = new FormData();

      this.selected.forEach((element, index) => {
        formData.append(`idFeriasArray[${index}]`, element.idFerias)
      });

      if (this.justificativa) {
        formData.append("justificativa_recusa_ferias", this.justificativa);
        this.refuse(formData);
        return;
      }
      
      this.sendForm(formData);
      return;
    },

    async approve(id) {
      this.loading.btnApprove = true;
      const response = await AnalisarFeriasService.aprovarFerias(id);
      this.loading.btnApprove = false;
      if (response) {
        this.close();
      }
    },

    async refuse(formData) {
      this.loading.btnRefuse = true;
      const response = await AnalisarFeriasService.recusarFeriasLote(formData);
      if (response) {
        this.justificativaDialog = false;
        this.justificativa = null;
        this.close();
      }
      this.loading.btnRefuse = false;

    },

    async sendForm(formData) {
      
      this.loading.btn = true;
      const response = await AnalisarFeriasService.aprovarFeriasLote(formData);
      this.loading.btn = false;
      if (response) {
        this.$emit('on-confirm');
        this.close();
      }
      this.loading.btn = false;
    },

    close() {
      this.$emit("on-close");
    },

  },
};